namespace $ { $mol_style_attach( "lim/rtest2/logo/logo.view.css",
 "[lim_rtest2_logo] {\n\tanimation: rotate 4s infinite;\n}\n\n@keyframes rotate {\n\t0% {\n\t\ttransform: rotate(0deg)\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg)\n\t}\n}\n"
) }